/**
 * About Euhomy 2 — Accordion Chapter (Pin + scroll/hover sync)
 * 放大/缩小用 clip-path；收尾缩小仅改尺寸，保留手风琴内容与背景
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 768px)';
  var DESKTOP_MQ = '(min-width: 769px)';
  var EASE = 'none';
  var EXPAND_DUR = 0.48;
  var SHRINK_DUR = 0.48;
  var CONTENT_INNER_PAD = 48;

  function remPx(n) {
    if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.remPx === 'function') {
      return window.AboutEuhomy2.remPx(n);
    }
    var rem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rem'));
    return (Number(n) || 0) * (Number.isFinite(rem) && rem > 0 ? rem : 1);
  }

  function q(root, sel) { return root ? root.querySelector(sel) : null; }
  function qa(root, sel) { return root ? Array.from(root.querySelectorAll(sel)) : []; }

  function getGutterPx(isMobile) {
    if (isMobile) {
      var mobile = getComputedStyle(document.documentElement).getPropertyValue('--design-gutter-mobile').trim();
      return parseFloat(mobile) || 15;
    }
    var rem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rem')) || 1;
    var gutter = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--design-gutter')) || 128;
    return rem * gutter;
  }

  function getPinHeight(pin) {
    return pin ? pin.offsetHeight : window.innerHeight;
  }

  var ITEM_SWITCH_DUR = 0.2;

  function measureNaturalHeight(body) {
    if (!body) return 0;
    var prevMax = body.style.maxHeight;
    var prevOp = body.style.opacity;
    var prevOv = body.style.overflow;
    body.style.maxHeight = 'none';
    body.style.opacity = '1';
    body.style.overflow = 'hidden';
    var h = Math.ceil(body.scrollHeight);
    body.style.maxHeight = prevMax;
    body.style.opacity = prevOp;
    body.style.overflow = prevOv;
    return h;
  }

  /* 锁定列表高度 = 全部标题行 + 最高正文，避免切换时整体重居中抖动 */
  function prepareAccordionItems(gsap, items) {
    var list = items[0] ? items[0].closest('[data-ae2-acc-items]') : null;
    var bodies = items.map(function (it) { return q(it, '[data-ae2-acc-body]'); }).filter(Boolean);
    var maxBody = 0;
    bodies.forEach(function (body) {
      var h = Math.min(remPx(360), measureNaturalHeight(body) + remPx(4));
      body.dataset.ae2AccBodyH = String(h);
      if (h > maxBody) maxBody = h;
    });
    if (list) {
      gsap.set(bodies, { maxHeight: 0, opacity: 0 });
      list.style.minHeight = '';
      var headsH = Math.ceil(list.getBoundingClientRect().height);
      list.style.minHeight = (headsH + maxBody) + 'px';
    }
    return maxBody;
  }

  function setActive(gsap, root, items, index, instant) {
    var dur = instant ? 0 : ITEM_SWITCH_DUR;
    items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === index);
      var body = q(item, '[data-ae2-acc-body]');
      if (!body) return;
      var targetH = parseFloat(body.dataset.ae2AccBodyH);
      if (!Number.isFinite(targetH) || targetH <= 0) {
        targetH = Math.min(remPx(360), measureNaturalHeight(body) + remPx(4)) || remPx(240);
        body.dataset.ae2AccBodyH = String(targetH);
      }
      /* 开合同时长，高度近似线性插值，避免中间塌陷 */
      if (i === index) {
        gsap.to(body, { maxHeight: targetH, opacity: 1, duration: dur, ease: EASE, overwrite: true });
      } else {
        gsap.to(body, { maxHeight: 0, opacity: 0, duration: dur, ease: EASE, overwrite: true });
      }
    });
    if (root) root.dataset.activeIndex = String(index);
  }

  function getCompactPad(root, side) {
    if (!root) return 0;
    /* 存的是设计稿无单位数值，需乘 --rem；勿依赖 calc() 自定义属性 */
    var raw = getComputedStyle(root).getPropertyValue('--ae2-acc-pad-' + side).trim();
    var n = parseFloat(raw);
    if (!Number.isFinite(n)) n = 0;
    return remPx(n);
  }

  function readClipState(root, isMobile) {
    return {
      t: getCompactPad(root, 'top'),
      r: getGutterPx(isMobile),
      b: getCompactPad(root, 'bottom'),
      l: getGutterPx(isMobile),
      radius: remPx(16),
    };
  }

  function applyClipVars(gsap, frame, state) {
    gsap.set(frame, {
      '--ae2-clip-t': state.t,
      '--ae2-clip-r': state.r,
      '--ae2-clip-b': state.b,
      '--ae2-clip-l': state.l,
      '--ae2-clip-radius': state.radius,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: 'auto',
      height: '100%',
      borderRadius: 0,
      clearProps: 'yPercent,xPercent,y,x',
    });
  }

  function initScrollExperience(ctx, root, isMobile) {
    var gsap = ctx.gsap;
    var headerOffset = ctx.headerOffset || 0;
    var pin = q(root, '[data-ae2-acc-pin]');
    var frame = q(root, '[data-ae2-acc-frame]');
    var content = q(root, '.ae2-acc__content');
    var panelCompact = q(root, '[data-ae2-acc-panel][data-panel="compact"]');
    var panelAccordion = q(root, '[data-ae2-acc-panel][data-panel="accordion"]');
    var items = qa(root, '[data-ae2-acc-item]');
    var bgCompact = q(root, '[data-ae2-acc-bg-compact]');
    var bgActive = q(root, '[data-ae2-acc-bg-active]');
    if (!pin || !frame || !items.length) return function () {};

    root.classList.remove('ae2-acc--static');
    root.classList.add('ae2-acc--immersive');

    function compactClip() {
      return readClipState(root, isMobile);
    }

    function fullClip() {
      return { t: 0, r: 0, b: 0, l: 0, radius: 0 };
    }

    /* 缩小态：clip 外 gutter + 卡片内边距；全屏：仅版心 gutter */
    function padCompact() {
      return getGutterPx(isMobile) + (isMobile ? remPx(20) : remPx(CONTENT_INNER_PAD));
    }

    function padFull() {
      return getGutterPx(isMobile);
    }

    if (bgCompact) gsap.set(bgCompact, { opacity: 1 });
    if (bgActive) gsap.set(bgActive, { opacity: 0 });
    applyClipVars(gsap, frame, compactClip());

    if (content) {
      gsap.set(content, { paddingLeft: padCompact(), paddingRight: padCompact() });
    }
    if (panelCompact) gsap.set(panelCompact, { opacity: 1, y: 0, pointerEvents: 'auto' });
    if (panelAccordion) gsap.set(panelAccordion, { opacity: 0, y: 10, pointerEvents: 'none' });
    prepareAccordionItems(gsap, items);
    setActive(gsap, root, items, 0, true);

    var segments = Math.max(items.length, 3);
    var pinLengthMultiplier = isMobile ? 2.85 + segments * 0.88 : 2.7 + segments * 1.15;
    var pinH = getPinHeight(pin);
    var pinLength = pinH * pinLengthMultiplier;
    var pinScroll = (window.AboutEuhomy2 && typeof window.AboutEuhomy2.getPinScrollOptions === 'function')
      ? window.AboutEuhomy2.getPinScrollOptions(isMobile)
      : { scrub: true, anticipatePin: 0, fastScrollEnd: false };

    var scrub = pinScroll.scrub === true ? 0.55 : Math.max(0.45, Number(pinScroll.scrub) || 0.45);

    var proxy = { index: 0 };
    var lastIndex = -1;

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: root,
        start: 'top top+=' + headerOffset,
        end: '+=' + pinLength,
        pin: pin,
        scrub: scrub,
        anticipatePin: pinScroll.anticipatePin,
        fastScrollEnd: pinScroll.fastScrollEnd,
        invalidateOnRefresh: true,
        onRefresh: function () {
          prepareAccordionItems(gsap, items);
          setActive(gsap, root, items, lastIndex >= 0 ? lastIndex : 0, true);
        },
      },
    });

    /* 1) 小 → 大 */
    tl.fromTo(frame, {
      '--ae2-clip-t': function () { return compactClip().t; },
      '--ae2-clip-r': function () { return compactClip().r; },
      '--ae2-clip-b': function () { return compactClip().b; },
      '--ae2-clip-l': function () { return compactClip().l; },
      '--ae2-clip-radius': function () { return compactClip().radius; },
    }, {
      '--ae2-clip-t': function () { return fullClip().t; },
      '--ae2-clip-r': function () { return fullClip().r; },
      '--ae2-clip-b': function () { return fullClip().b; },
      '--ae2-clip-l': function () { return fullClip().l; },
      '--ae2-clip-radius': function () { return fullClip().radius; },
      duration: EXPAND_DUR,
      ease: EASE,
      immediateRender: false,
    }, 0);

    if (content) {
      tl.fromTo(content, {
        paddingLeft: padCompact,
        paddingRight: padCompact,
      }, {
        paddingLeft: padFull,
        paddingRight: padFull,
        duration: EXPAND_DUR,
        ease: EASE,
        immediateRender: false,
      }, 0);
    }

    tl.to({}, { duration: 0.1 }, EXPAND_DUR - 0.02);

    var base = EXPAND_DUR + 0.1;
    var bgSwapStart = base - 0.04;
    var bgSwapDur = 0.34;
    if (bgActive && bgCompact) {
      tl.to(bgCompact, { opacity: 0, duration: bgSwapDur, ease: EASE }, bgSwapStart);
      tl.to(bgActive, { opacity: 1, duration: bgSwapDur, ease: EASE }, bgSwapStart);
    }
    if (panelCompact && panelAccordion) {
      tl.to(panelCompact, { opacity: 0, y: -8, duration: 0.22, ease: EASE }, base - 0.02);
      tl.set(panelCompact, { pointerEvents: 'none' }, base + 0.04);
      tl.to(panelAccordion, { opacity: 1, y: 0, duration: 0.28, ease: EASE }, base + 0.02);
      tl.set(panelAccordion, { pointerEvents: 'auto' }, base + 0.06);
    }

    /* 手风琴阶段必须在背景切换完全结束后，避免 hover/点击 scrub 回背景过渡 */
    var proxyStart = bgSwapStart + bgSwapDur + 0.08;
    var proxyDur = 0.9;
    var manualOverride = false;
    var manualTimer = null;
    tl.to(proxy, {
      index: items.length - 1,
      duration: proxyDur,
      ease: EASE,
      onUpdate: function () {
        if (manualOverride) return;
        var i = Math.max(0, Math.min(items.length - 1, Math.round(proxy.index)));
        if (i !== lastIndex) {
          lastIndex = i;
          setActive(gsap, root, items, i);
        }
      },
    }, proxyStart);

    /* 3) 大 → 小：只缩尺寸，保留手风琴内容与背景 */
    var shrinkStart = proxyStart + proxyDur + 0.12;

    tl.to(frame, {
      '--ae2-clip-t': function () { return compactClip().t; },
      '--ae2-clip-r': function () { return compactClip().r; },
      '--ae2-clip-b': function () { return compactClip().b; },
      '--ae2-clip-l': function () { return compactClip().l; },
      '--ae2-clip-radius': function () { return compactClip().radius; },
      duration: SHRINK_DUR,
      ease: EASE,
    }, shrinkStart);

    if (content) {
      tl.to(content, {
        paddingLeft: padCompact,
        paddingRight: padCompact,
        duration: SHRINK_DUR,
        ease: EASE,
      }, shrinkStart);
    }

    function goIndex(i) {
      if (tl.time() < proxyStart - 0.02) return;
      /* 只切换条目，不 tweenTo 时间轴，避免背景图被 scrub 回切换态 */
      manualOverride = true;
      if (manualTimer) window.clearTimeout(manualTimer);
      manualTimer = window.setTimeout(function () {
        manualOverride = false;
      }, 900);
      lastIndex = i;
      setActive(gsap, root, items, i);
    }

    function onItemActivate(i) {
      if (isMobile) {
        setActive(gsap, root, items, i);
        return;
      }
      goIndex(i);
    }

    items.forEach(function (item, i) {
      if (isMobile) {
        item.addEventListener('click', function () { onItemActivate(i); });
      } else {
        item.addEventListener('mouseenter', function () { onItemActivate(i); }, { passive: true });
        item.addEventListener('click', function (e) {
          e.preventDefault();
          onItemActivate(i);
        });
        item.addEventListener('focusin', function () { onItemActivate(i); });
      }
    });

    return function () {
      if (manualTimer) window.clearTimeout(manualTimer);
      root.classList.remove('ae2-acc--immersive');
      if (tl.scrollTrigger) tl.scrollTrigger.kill();
      tl.kill();
    };
  }

  function initStaticMobile(ctx, root) {
    var gsap = ctx.gsap;
    var frame = q(root, '[data-ae2-acc-frame]');
    var content = q(root, '.ae2-acc__content');
    var panelCompact = q(root, '[data-ae2-acc-panel][data-panel="compact"]');
    var panelAccordion = q(root, '[data-ae2-acc-panel][data-panel="accordion"]');
    var items = qa(root, '[data-ae2-acc-item]');
    var bgCompact = q(root, '[data-ae2-acc-bg-compact]');
    var bgActive = q(root, '[data-ae2-acc-bg-active]');
    if (!items.length) return function () {};

    root.classList.remove('ae2-acc--immersive');
    root.classList.add('ae2-acc--static');

    if (frame) {
      gsap.set(frame, {
        clearProps: 'all',
        '--ae2-clip-t': 0,
        '--ae2-clip-r': 0,
        '--ae2-clip-b': 0,
        '--ae2-clip-l': 0,
        '--ae2-clip-radius': 14,
      });
    }
    if (content) gsap.set(content, { clearProps: 'paddingLeft,paddingRight' });
    if (bgCompact) gsap.set(bgCompact, { opacity: 0 });
    if (bgActive) gsap.set(bgActive, { opacity: 1 });
    if (panelCompact) gsap.set(panelCompact, { opacity: 0, pointerEvents: 'none', display: 'none' });
    if (panelAccordion) gsap.set(panelAccordion, { opacity: 1, y: 0, pointerEvents: 'auto', display: 'flex' });

    prepareAccordionItems(gsap, items);
    setActive(gsap, root, items, 0, true);

    items.forEach(function (item, i) {
      item.addEventListener('click', function () {
        setActive(gsap, root, items, i);
      });
    });

    return function () {
      root.classList.remove('ae2-acc--static');
    };
  }

  function init(ctx) {
    var root = document.querySelector('[data-ae2-acc]');
    if (!root) return;

    var mm = ctx.gsap.matchMedia();
    var cleanup = null;

    if (ctx.reducedMotion) {
      mm.add(MOBILE_MQ, function () { cleanup = initStaticMobile(ctx, root); });
      mm.add(DESKTOP_MQ, function () {
        var items = qa(root, '[data-ae2-acc-item]');
        if (items.length) setActive(ctx.gsap, root, items, 0);
      });
      return function () { if (cleanup) cleanup(); mm.revert(); };
    }

    mm.add(DESKTOP_MQ, function () { cleanup = initScrollExperience(ctx, root, false); });
    mm.add(MOBILE_MQ, function () { cleanup = initScrollExperience(ctx, root, true); });
    return function () { if (cleanup) cleanup(); mm.revert(); };
  }

  if (window.AboutEuhomy2 && typeof window.AboutEuhomy2.register === 'function') {
    window.AboutEuhomy2.register(init);
  }
})();
